import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Check } from 'lucide-react';

const MobileSelectDropdown = ({ value, options, onChange, placeholder = "선택" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Click Outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedOption = options.find(o => o.value === value);
    const displayLabel = selectedOption ? selectedOption.label : value;

    return (
        <div className="relative w-full" ref={dropdownRef}>
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className={`w-full h-10 bg-white border rounded-xl text-sm font-bold flex items-center justify-between px-3 shadow-sm focus:outline-none transition-all ${isOpen ? 'border-[#354F38] ring-2 ring-[#354F38]/10' : 'border-gray-200'}`}
            >
                <span className="truncate text-gray-700">{displayLabel || placeholder}</span>
                <ChevronDown size={16} className={`text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-100 rounded-xl shadow-xl overflow-hidden z-[9999] py-1 animate-in fade-in zoom-in-95 duration-200 origin-top">
                    {options.map((option) => (
                        <button
                            key={option.value}
                            type="button"
                            onClick={() => {
                                onChange(option.value);
                                setIsOpen(false);
                            }}
                            className={`w-full text-left px-3 py-2.5 text-sm font-bold flex items-center justify-between transition
                                ${option.value === value ? 'bg-[#E3F9E5] text-[#354F38]' : 'text-gray-600 hover:bg-gray-50'}
                            `}
                        >
                            <span>{option.label}</span>
                            {option.value === value && <Check size={14} strokeWidth={3} />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MobileSelectDropdown;
